import { openNewTab } from "./openNewTab";

export const contactSupport = () => {
  openNewTab(
    "portal.usepylon.com/intelligems/forms/intelligems-support-request",
    "Pylon Support Request"
  );
};

export const contactSales = () => {
  window.open("mailto:sales@intelligems.io?subject=Intelligems Sales Request");
};
